import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DataService } from '../../../../service/data.service';
import { formatFlexibleDate } from '../../../../utils/safe-date.util';

@Component({
    selector: 'app-resource-liabilities-expenses-en-v2',
    templateUrl: './resource-liabilities-expenses-en-v2.component.html',
    styleUrls: ['./resource-liabilities-expenses-en-v2.component.css'],
    standalone: false
})
export class ResourceLiabilitiesExpensesEnV2Component implements OnInit, OnChanges {

  constructor(private dataSource: DataService) { }

  @Input() returnData
  @Input() printActive:boolean

  dateAfterSign:string
  restructuredData:any = {}
  totalSourcesOfFund: number
  totalAssetsAndLastYearAssets: number
  annualLivingExpense: number
  lossAndGiftExpense: number
  totalLivingExpense: number
  lastDateNetAssets: number
  liabilitiesOutsideBusiness: number
  totalBusinessAssets:number
  businessLiabilities: number

  totalNonAgriPropertyValue:any
  totalFinancialAssets: number
  totalSavedCash: number
  totalAssetsInsideBD: number
  totalAssets:number | string
  ornamentDetails: string
  assessmentYearStart: string

  ngOnInit(): void {
    this.dataSource.data$.subscribe(data=>{
      const currentAssessmentYear = this.returnData.submissionInfo.assessmentYear;
      this.assessmentYearStart = currentAssessmentYear?.split('-')[0];
    })
  }

  ngOnChanges(){
    this.dateAfterSign = this.formatDate(this.returnData?.submissionInfo?.submissionDate);

    this.returnData?.headSummery?.assetsAndLiabilities?.forEach(item => {
      const { typeKey, firstSubTypeKey, secondSubTypeKey, amountHelperOfAL } = item;

      if (!this.restructuredData[typeKey]) {
        this.restructuredData[typeKey] = {};
      }

      if (!this.restructuredData[typeKey][firstSubTypeKey]) {
        this.restructuredData[typeKey][firstSubTypeKey] = {};
      }

      if (secondSubTypeKey === "") {
        this.restructuredData[typeKey][firstSubTypeKey] = amountHelperOfAL;
      } else {
        this.restructuredData[typeKey][firstSubTypeKey][secondSubTypeKey] = amountHelperOfAL;
      }
    });

   this.nonCashBenefitView();
    this.totalSourcesOfFund = (this.restructuredData?.sources_of_fund?.income_shown_in_the_return?.value ?? 0) +
                              (this.restructuredData?.sources_of_fund?.tax_exempted_income_and_allowances?.value ?? 0) +
                              (this.restructuredData?.sources_of_fund?.other_receipts?.value ?? 0);

    this.totalAssetsAndLastYearAssets = this.totalSourcesOfFund + (this.restructuredData?.previous_net_wealth?.previous_income_year_net_wealth?.value ??0)

    this.annualLivingExpense = this.restructuredData?.["0ther_outflow"]?.annual_living_expense?.value
    this.lossAndGiftExpense = (this.restructuredData?.["0ther_outflow"]?.loss_deduction_other_expense?.value ??0)
                                     + (this.restructuredData?.["0ther_outflow"]?.gift_donation_and_contribution?.value??0)

    this.totalLivingExpense = (isNaN(+this.annualLivingExpense) ? 0 : +this.annualLivingExpense) +(isNaN(+this.lossAndGiftExpense) ? 0 : +this.lossAndGiftExpense);

    this.lastDateNetAssets = this.totalAssetsAndLastYearAssets - this.totalLivingExpense

    this.liabilitiesOutsideBusiness =
      (isNaN(+this.restructuredData?.liabilities?.borrowing_from_bank_or_other_fi?.value) ? 0 : +this.restructuredData?.liabilities?.borrowing_from_bank_or_other_fi?.value) +
      (isNaN(+this.restructuredData?.liabilities?.unsecured_loan?.value) ? 0 : +this.restructuredData?.liabilities?.unsecured_loan?.value) +
      (isNaN(+this.restructuredData?.liabilities?.other_loan_or_overdraft?.value) ? 0 : +this.restructuredData?.liabilities?.other_loan_or_overdraft?.value);

    this.totalBusinessAssets = this.restructuredData?.assets?.business_capital?.business_capital_other_than_directors_shareholdings_in_limited_companies?.businessAssetValue

    this.businessLiabilities = this.restructuredData?.assets?.business_capital?.business_capital_other_than_directors_shareholdings_in_limited_companies?.businessLiabilitiesValue

    this.totalNonAgriPropertyValue = (isNaN(+this.restructuredData?.assets?.non_agricultural_property_parent?.non_agricultural_property_child?.value)  ? 0 : +this.restructuredData?.assets?.non_agricultural_property_parent?.non_agricultural_property_child?.value) +
      (isNaN(+this.restructuredData?.assets?.non_agricultural_property_parent?.advance_made_for_non_agricultural_property?.value) ? 0 : +this.restructuredData?.assets?.non_agricultural_property_parent?.advance_made_for_non_agricultural_property?.value);

    this.totalFinancialAssets =
      (isNaN(+this.restructuredData?.assets?.financial_assets?.share_debenture_etc?.value) ? 0 : +this.restructuredData?.assets?.financial_assets?.share_debenture_etc?.value) +
      (isNaN(+this.restructuredData?.assets?.financial_assets?.savings_certificate_bonds_and_other_government_securities?.value) ? 0 : +this.restructuredData?.assets?.financial_assets?.savings_certificate_bonds_and_other_government_securities?.value) +
      (isNaN(+this.restructuredData?.assets?.financial_assets?.dps?.value) ? 0 : +this.restructuredData?.assets?.financial_assets?.dps?.value) +
      (isNaN(+this.restructuredData?.assets?.financial_assets?.loans_given_to_others?.value) ? 0 : +this.restructuredData?.assets?.financial_assets?.loans_given_to_others?.value) +
      (isNaN(+this.restructuredData?.assets?.financial_assets?.fix_deposits_term_deposits_and_dps?.value) ? 0 : +this.restructuredData?.assets?.financial_assets?.fix_deposits_term_deposits_and_dps?.value) +
      (isNaN(+this.restructuredData?.assets?.financial_assets?.provident_fund_and_other_fund?.value) ? 0 : +this.restructuredData?.assets?.financial_assets?.provident_fund_and_other_fund?.value) +
      (isNaN(+this.restructuredData?.assets?.financial_assets?.other_financial_assets?.value) ? 0 : +this.restructuredData?.assets?.financial_assets?.other_financial_assets?.value);

    this.totalSavedCash =
      (isNaN(+this.restructuredData?.assets?.cash_and_fund_outside_business?.notes_and_currencies?.value) ? 0 : +this.restructuredData?.assets?.cash_and_fund_outside_business?.notes_and_currencies?.value) +
      (isNaN(+this.restructuredData?.assets?.cash_and_fund_outside_business?.hand_cash?.value) ? 0 : +this.restructuredData?.assets?.cash_and_fund_outside_business?.hand_cash?.value) +
      (isNaN(+this.restructuredData?.assets?.cash_and_fund_outside_business?.other_deposits_balance_and_advance?.value) ? 0 : +this.restructuredData?.assets?.cash_and_fund_outside_business?.other_deposits_balance_and_advance?.value);

    this.totalAssetsInsideBD =
      (isNaN(+this.totalBusinessAssets) ? 0 : +this.totalBusinessAssets) -
      (isNaN(+this.businessLiabilities) ? 0 : +this.businessLiabilities) +
      (isNaN(+this.restructuredData?.assets?.business_capital?.director_shareholdings_in_limited_companies?.value) ? 0 : +this.restructuredData?.assets?.business_capital?.director_shareholdings_in_limited_companies?.value) +
      (isNaN(+this.restructuredData?.assets?.business_capital?.capital_of_partnership_firm?.value) ? 0 : +this.restructuredData?.assets?.business_capital?.capital_of_partnership_firm?.value) +
      (isNaN(+this.totalNonAgriPropertyValue) ? 0 : +this.totalNonAgriPropertyValue) +
      (isNaN(+this.restructuredData?.assets?.agricultural_property?.value) ? 0 : +this.restructuredData?.assets?.agricultural_property?.value) +
      (isNaN(+this.totalFinancialAssets) ? 0 : +this.totalFinancialAssets) +
      (isNaN(+this.restructuredData?.assets?.motor_car?.value) ? 0 : +this.restructuredData?.assets?.motor_car?.value) +
      (isNaN(+this.restructuredData?.assets?.gold_diamond_gems_and_other_items?.value) ? 0 : +this.restructuredData?.assets?.gold_diamond_gems_and_other_items?.value) +
      (isNaN(+this.restructuredData?.assets?.furniture_equipments_and_electronic_items?.value) ? 0 : +this.restructuredData?.assets?.furniture_equipments_and_electronic_items?.value) +
      (isNaN(+this.restructuredData?.assets?.other_assets_of_significant_value?.value) ? 0 : +this.restructuredData?.assets?.other_assets_of_significant_value?.value) +
      (isNaN(+this.totalSavedCash) ? 0 : +this.totalSavedCash);

    this.totalAssets = this.returnData?.profileData?.mandatoryITTenB
      ? ((isNaN(+this.totalAssetsInsideBD) ? 0 : +this.totalAssetsInsideBD) +
        (isNaN(+this.restructuredData?.assets?.outside_property?.value) ? 0 : +this.restructuredData?.assets?.outside_property?.value))
      : (isNaN(+this.returnData?.profileData?.grossWealth) ? 0 : +this.returnData?.profileData?.grossWealth);

    this.ornamentDetails = this.getOrnamentDetails(this.restructuredData?.assets?.gold_diamond_gems_and_other_items?.otherInfo)
  }

  private formatDate(dateValue: string | Date): string {
    return formatFlexibleDate(dateValue, '/');
  }

  nonCashBenefitView(): void {
    let income = this.restructuredData?.sources_of_fund?.income_shown_in_the_return?.value ?? 0;
    let exempted = this.restructuredData?.sources_of_fund?.tax_exempted_income_and_allowances?.value ?? 0;
    let deed = this.returnData?.taxPaymentData?.poti_DEEMED_Amt ?? 0;

    if (income > deed) {
      income -= deed;
    } else {
      exempted -= (deed - income);
      income = 0;
    }
    if (this.restructuredData?.sources_of_fund?.income_shown_in_the_return) {
      this.restructuredData.sources_of_fund.income_shown_in_the_return.value = income;
    }
    if (this.restructuredData?.sources_of_fund?.tax_exempted_income_and_allowances) {
      this.restructuredData.sources_of_fund.tax_exempted_income_and_allowances.value = Math.max(exempted, 0);
    }
  }

  getOrnamentDetails(items){
    if(!items){
      return ''
    }

    function getSingleOrnamentString(item){
      let type,amount,unit

      amount =  Intl.NumberFormat('en-IN').format((parseFloat(item.endYrAmount)));
      type = item.description;
      unit = item.name;

      return type + ' ' + amount + ' ' + unit
    }

    return '(' + items.reduce((accu,item,index)=>{
      return accu + (index === 0 ? '' : ' ') + getSingleOrnamentString(item) + (index === items.length - 1 ? '' : ',')
    },'') + ')'
  }
}
